// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"visually-hidden-module-visuallyHidden--3ed0c"};